import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { merge, omit, map, get, pick } from 'lodash';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';

import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../redux/actionCreators/sync/jobrequests';
import { convertContactsToMenuItems } from '../../../../redux/helpers/staticData';

import * as companyApi from '../../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../../redux/actionCreators/sync/companies';

import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import Button from '../../../../common/components/Button';

import { validate } from '../../../../modelValidator';

import SubmissionBar from '../../SubmissionBar';
import RouteTransitionBlocker from '../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

import AddAdditionalContacts from './AddAdditionalContacts';
import AdditionalContactModel from './AdditionalContactModel';

@connect((store, props) => {
	return {
		user: store.user,
		jobId: parseInt(props.params.jobId || 0, 10),
		jobRequest: store.jobRequest,
		contacts: store.companyContacts
	};
})
class AdditionalContacts extends Component {

	static propTypes = {
		user: PropTypes.object,
		checkComplete: PropTypes.func,
		jobRequest: PropTypes.object,
		params: PropTypes.object,
	}

	constructor(props, context) {
		super(props, context);

		this.state = {
			dirty: false,
			submitted: false,
			valid: true,
			exitWithoutSubmit: false,
			errors: [],
			showAddContact: false,
			showTransitionBlocker: false,
			jobRequestModel: props.jobRequest,
			transitionRoute: '',
      contact: {
        companyId: props.user.companyId,
        email: undefined,
        phoneNumber1: undefined,
        title: undefined,
        lastName: undefined,
        firstName: undefined,
        workTypeDescription: props.user.workypeDescription,
        foundUsVia: null,
        address: undefined,
        city: undefined,
        state: undefined,
        zip: undefined,
      }
		};

    this.AdditionalContactModel = AdditionalContactModel.getModel();

		this.routeLeaveHook = ::this.routeLeaveHook;
    this.handleAdd = ::this.handleAdd;
    this.add = ::this.add;
    this.handleNewContactChange = ::this.handleNewContactChange;
    this.validateForm = ::this.validateForm;

	}


	componentDidMount() {
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.jobRequest) {
			this.setState({
				jobRequestModel: nextProps.jobRequest,
				contacts: nextProps.contacts
			});
		}
	}

	routeLeaveHook(location) {

		if(!this.state.dirty || this.state.submitted || this.state.exitWithoutSubmit) {
			return true;
		}


		const CreateJobRequestRoute = /\/client\/jobrequest\/(.*)\/?(.*)/;
		const isLocationInsideCreateJobRequest = CreateJobRequestRoute.test(location.pathname);

		this.setState({
			primaryButtonLabel: isLocationInsideCreateJobRequest ? 'Stay' : undefined,
			secondaryButtonLabel: isLocationInsideCreateJobRequest ? 'Leave': undefined,
		});

		this.setState({
			showTransitionBlocker: true,
			transitionRoute: location.pathname
		});

		return false;
	}

  validateForm() {
    const validationErrors = validate(this.state.contact, this.AdditionalContactModel);
    const errors = validationErrors.length > 0 ? ['Please fill in all required fields.'] : [];
    this.setState({errors});
    return errors.length > 0;
  }


  handleNewContactChange(prop, value) {
    const contact = merge({}, this.state.contact);
    contact[prop] = value;
    this.setState({ contact, dirty: true });
  }

  handleAdd() {

    if (this.state.errors.length > 0) {
      return false;
    }

    this.add(this.state.contact)
      .then(() => Promise.resolve(true))
      .catch(err =>  {
        const message = get(err, '[0].errorMessage');
        this.setState({ errors: message ? [message] : [] });
        return Promise.reject(err);
    });
  }

  add = (contact) => {
    const companyContacts = this.props.contacts;
    const newContact = {
      user: pick(contact, ['firstName', 'lastName', 'email', 'phoneNumber1', 'phoneExtension1', 'address', 'city', 'state', 'zip']),
      profile: pick(contact, ['companyId', 'title', 'foundUsVia'])
    };

		const addContact = (contactInfo) => this.props.dispatch(companyApi.addCompanyContacts(contactInfo));

		const updateContactsStore = (contactInfo) => {
			this.props.dispatch(companyStore.updateCompanyContacts([...companyContacts, contactInfo]));
			return contactInfo;
		};

		return addContact(newContact)
			.then(updateContactsStore)
			.then((newContactInfo) => {
        // instead of select Contact, manually set ID in state in handleSave();
        // this.selectContact(contactInfo.profile.id);
        this.handleSave(newContactInfo);
      })
      .catch((err) => {
        if (err.errors) {
          console.log(err, 'Error adding Reporting Contact');
          this.setState({errors: [err.errors[0].errorMessage]})
        }
      });
	}

  handleSave = (newContactInfo) => {

    const newState = merge({}, this.state);
    if (newContactInfo) {
      newState.showAddContact = false;
      const contactId = newContactInfo.profile.id;
      newState.jobRequestModel.reportingContactId = contactId;
    }

    const updateJobRequest = (profileId, jobRequest) => this.props.dispatch(jobRequestApi.updateJobRequest(profileId, jobRequest));
    const updateJobRequestStore = (jobRequest) => this.props.dispatch(jobRequestStore.updateJobRequest(jobRequest));

    return updateJobRequest(this.props.user.profileId, omit(newState.jobRequestModel, ['primaryContact']))
    .then(() => updateJobRequestStore(newState.jobRequestModel))
    .then(() => {
      this.setState({submitted: true }, () => {
        this.props.checkComplete();
        this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/authorize`));
      });
    })
    .catch((err) => {
      console.log(err);
    });
  }

	handleSaveAndNext = () => {
    if (this.state.showAddContact) {
      if (this.validateForm()) {
        return;
      }
      this.handleAdd();
    } else {
      return this.handleSave(null);
    }
	}

	handleBack = () => {
		this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/workschedule`));
	}

	handleNew = () => {
		this.setState({ showAddContact: true, dirty: true });
	}

	handleChange = (event, value) => {
		this.selectContact(value);
	}

	closeTransitionBlocker = () => {
		this.setState({showTransitionBlocker: false });
	}

	transitionFunction = () => {
		this.setState({exitWithoutSubmit: true}, () =>  this.props.dispatch(push(this.state.transitionRoute)));
	}

	contactsToMenuItems(contacts) {
    return map(contacts, function(contact) {
      return {
        value: contact.profile.id,
        primaryText: contact.user.firstName + ' ' + contact.user.lastName
      };
    });
  }

	selectContact = (contactId) => {
		const newState = merge({}, this.state);
		newState.showAddContact = false;
		newState.jobRequestModel.reportingContactId = contactId;
		this.setState({...newState, errors: []});
	}

  cancel () {

    const contact = {
      companyId: this.props.user.companyId,
      email: undefined,
      phoneNumber1: undefined,
      title: undefined,
      lastName: undefined,
      firstName: undefined,
      workTypeDescription: this.props.user.workypeDescription,
      foundUsVia: null,
      address: undefined,
      city: undefined,
      state: undefined,
      zip: undefined,
    };

    this.setState({contact, dirty: false, submitted: false, showAddContact: false, errors: []});

  }

  render() {

	return (
		<div className='additional-contacts'>

			{
				this.state.showTransitionBlocker
				&&
				<RouteTransitionBlocker
					cancelAction={this.closeTransitionBlocker.bind(this)}
					primaryAction={this.closeTransitionBlocker.bind(this)}
					primaryButtonLabel={this.state.primaryButtonLabel}
					secondaryAction={this.transitionFunction.bind(this)}
					secondaryButtonLabel={this.state.secondaryButtonLabel}
					transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
				/>
			}
			<h1>Reporting Contact </h1>
			<h2>Please select your reporting contact for this position or create a new one.</h2>

      <div className='reporting-contact-select-button'>
        <DropDownMenu
          data-id='Reporting Contact'
          disabled={this.state.showAddContact}
          value={this.state.jobRequestModel.reportingContactId}
          onChange={this.handleChange}
          className='reporting-contact-select'
          floatingLabelText='Reporting Contact'
          menuItems={convertContactsToMenuItems(this.props.contacts)}
          includeDefault
        />

        <Button
          onClick={this.handleNew}
          className='button-secondary'
          disabled={!!this.state.showAddContact}
          label='NEW' />
      </div>


			{this.state.showAddContact
				&&
				<AddAdditionalContacts
          handleChange={this.handleNewContactChange}
					selectContact={this.selectContact}
          contact={this.state.contact}
          cancel={::this.cancel}
					jobId={this.props.jobId}
				/>
			}

			<SubmissionBar
        hideBack
				onBack={this.handleBack}
				onNext={this.handleSaveAndNext}
				onSave={this.handleSave}
				errors={this.state.errors}
        showError={this.state.dirty}
			/>

	</div>
	);
  }
}
export default withRouter(AdditionalContacts);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/AdditionalContacts/index.js